import { render, staticRenderFns } from "./postRepost.vue?vue&type=template&id=7fc28892&lang=pug&"
import script from "./postRepost.vue?vue&type=script&lang=js&"
export * from "./postRepost.vue?vue&type=script&lang=js&"
import style0 from "./postRepost.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "postRepost.vue"
export default component.exports